enum BraceletStatusTypeEnum {
  ACTIVE = 'active',
  DISABLED = 'disabled',
}

export default BraceletStatusTypeEnum;
